import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import "./AgriStackComponent.css";
import "react-awesome-slider/dist/styles.css";
import AgriTechStack from "../../images/agriculture.png";
import { NavLink } from "react-router-dom";
import { Typography } from "@material-ui/core";
// ======================================================
// Data: List of available API technology stacks
// Each stack has a title, image, and navigation path
// ======================================================
const stackData = [
  {
    title: "Core Stack", // Title displayed below the image
    image: AgriTechStack, // Image representing the Core Stack
    path: "/core-stack", // Navigation link to Core Stack details
  },
  {
    title: "AgriCloud Stack",
    image: AgriTechStack,
    path: "/agri-cloudstack",
  },
  {
    title: "EdgeAI Stack",
    image: AgriTechStack,
    path: "/edge-ai-stack",
  },
];

// ======================================================
// AgriStackComponent: Displays API stacks with a responsive grid layout
// ======================================================
const AgriStackComponent = () => {
  return (
    // Main container for the API stack section
    <div maxwidth={12} className="businessPartnerContainer explore-app-background">
      <Container maxWidth="sm" className="gridSection gridSection--mod">
        {/* Grid layout for displaying API stack options */}
        <Grid 
          container={true} 
          alignItems="center"
          spacing={1} 
          direction="row" 
          justifyContent="center"
        >
          {/* Mapping through stackData array to generate stack cards dynamically */}
          {stackData.map(({ title, image, path }, index) => {
            return (
              <Grid
                item
                md={2} // Medium screens: 2 columns
                sm={4} // Small screens: 4 columns
                xs={6} // Extra small screens: 6 columns
                key={index} // Unique key for each Grid item
                className="stack-data-container"
              >
                {/* Navigation link to the respective API stack page */}
                <NavLink to={path}>
                  <img src={image} alt={title} />
                  <Typography variant="h4" align="center">
                    {title}
                  </Typography>
                </NavLink>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};

export default AgriStackComponent;
